import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"

const useStyles = makeStyles(({
	item: {
		maxWidth: 420
	},
	text: {
		fontSize: "28px",
		color: colors.gray[800],
		fontWeight: 500
	},
	description: {
		fontSize: "16px",
		color: colors.gray[400],
		textAlign: "center"
	},
	button: {
		width: "100%"
	}
}))

export default useStyles
